import { useCallback, useMemo } from 'react';
import { useEditorAutoSavingStatus, useGetEditorThread } from 'src/hooks';
import { useGetUser } from '../userHooks';
import { useUpdateEditorThreadMutation } from 'src/store/services';

export const useDocumentAutoSave = () => {
  const { editorThread } = useGetEditorThread();
  const { user_id } = useGetUser();
  const { onChangeAutoSavingStatus } = useEditorAutoSavingStatus();

  const [updateEditorThread] = useUpdateEditorThreadMutation();

  const onDocumentAutoSave = useCallback(
    async (markdown: string) => {
      onChangeAutoSavingStatus('loading');

      const contents =
        !!editorThread?.artifact?.contents &&
        editorThread.artifact.contents.length > 0
          ? editorThread.artifact.contents.map((item) => {
              if (item.index === editorThread?.artifact?.currentIndex) {
                return { ...item, fullMarkdown: markdown };
              } else {
                return item;
              }
            })
          : [
              {
                fullMarkdown: markdown,
                index: 1,
                type: 'text',
              },
            ];

      try {
        const result = await updateEditorThread({
          user_id,
          thread_id: editorThread?.thread_id || '',
          thread: {
            ...editorThread,
            artifact: {
              ...editorThread?.artifact,
              contents,
            },
          },
        }).unwrap();

        if (result) {
          onChangeAutoSavingStatus('success');
        }
      } catch (error) {
        onChangeAutoSavingStatus('error');
      } finally {
        onChangeAutoSavingStatus(null);
      }
    },
    [editorThread, onChangeAutoSavingStatus, updateEditorThread, user_id],
  );

  return useMemo(() => ({ onDocumentAutoSave }), [onDocumentAutoSave]);
};
